export const state = {
    qr_item_data: null,
}